// IMPORT PACKAGE REFERENCES
import React, { Component, Fragment } from 'react';

import { AnalysisCard } from '../AnalysisCard/AnalysisCard';
import Can from '../Can';
import { DocumentSectionList } from './DocumentSectionList';
import { DoesNotHaveActiveAnalysis } from '../HasActiveAnalysis';
// IMPORT PROJECT REFERENCES
import { Link } from 'react-router-dom';
import MonitoredDocumentBrowser from '../MonitoredDocument/MonitoredDocumentBrowser.container';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/dateUtils';

// COMPONENT
class DocumentViewer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { document, toggleEditMode, close } = this.props;

        return (
            <div>
                <div>
                    <dl>
                        <dt>Vendor</dt>
                        <dd>{document.vendor ? document.vendor.name : 'N/A'}</dd>

                        <dt>Product</dt>
                        <dd>{document.product ? document.product.name : 'N/A'}</dd>

                        {!document.markdownConverted && <dt>Markdown Status</dt>}
                        {!document.markdownConverted && (
                            <dd>
                                {document.markdownConverted !== null
                                    ? document.markdownMessage
                                    : 'In-progress'}
                            </dd>
                        )}

                        {document.markdownConverted && <dt>Markdown</dt>}
                        {document.markdownConverted && (
                            <dd>
                                <Link
                                    className="card-link"
                                    to={{
                                        pathname: `/markdown/${document.id}`,
                                        state: { backLink: `/document/${document.id}` },
                                    }}
                                >
                                    View
                                </Link>
                            </dd>
                        )}

                        <dt>Created</dt>
                        <dd>{document.created ? formatDate(document.created) : 'N/A'}</dd>

                        <dt>Updated</dt>
                        <dd>{document.updated ? formatDate(document.updated) : 'N/A'}</dd>

                        <dt>URL</dt>
                        <dd>{document.url ? document.url : 'N/A'}</dd>

                        <dt>Description</dt>
                        <dd>{document.description ? document.description : 'N/A'}</dd>

                        <dt>Sections</dt>
                        <dd>
                            <div className="card mb-3">
                                <div className="card-body">
                                    <DocumentSectionList
                                        documentId={document.id}
                                        sections={document.sections}
                                    />
                                </div>
                            </div>
                        </dd>

                        {document.analysis && <AnalysisCard analysis={document.analysis} />}
                    </dl>
                </div>
                <div className="row d-flex flex-row-reverse">
                    <div className="p-2">
                        <button
                            type="button"
                            onClick={close}
                            className="btn btn-secondary mb-2 ml-2"
                        >
                            Close
                        </button>
                    </div>
                    <Can I="update" a="Document">
                        <div className="p-2">
                            <DoesNotHaveActiveAnalysis analysis={document.analysis}>
                                <button
                                    type="button"
                                    onClick={toggleEditMode}
                                    className="btn btn-primary mb-2 ml-2"
                                >
                                    Edit
                                </button>
                            </DoesNotHaveActiveAnalysis>
                        </div>
                    </Can>
                </div>
                {/*
                    Only mount this for a monitored document. It fetches the monitored document and
                    its versions on mount, and an unmonitored document has no row in the monitoring
                    schema, so both requests 404 -- harmlessly, but on every document page view.
                */}
                {document.monitored && (
                    <Fragment>
                        <hr />
                        <div className="row ml-0 mr-0">
                            <MonitoredDocumentBrowser
                                documentId={document.id}
                                backLink={`/document/${document.id}`}
                            />
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }
}

DocumentViewer.propTypes = {
    document: PropTypes.object.isRequired,
    toggleEditMode: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
};

// EXPORT COMPONENT
export { DocumentViewer };
